import { render, staticRenderFns } from "./TakeDealModal.vue?vue&type=template&id=ebce028e&"
import script from "./TakeDealModal.vue?vue&type=script&lang=js&"
export * from "./TakeDealModal.vue?vue&type=script&lang=js&"
import style0 from "./TakeDealModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports